"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendTo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-alert */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
const react_1 = require("react");
const de_ui_1 = require("@delab-team/de-ui");
const uuid_1 = require("uuid");
const ton_1 = require("ton");
const ton3_1 = require("ton3");
const qr_scanner_1 = __importDefault(require("qr-scanner"));
const qrcode_reader_1 = __importDefault(require("qrcode-reader"));
const react_i18next_1 = require("react-i18next");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const tonapi_1 = require("../../../../logic/tonapi");
const smlAddr_1 = require("../../../../helpers/smlAddr");
const formatTimestamp_1 = require("../../../../helpers/formatTimestamp");
const rawToTon_1 = require("../../../../helpers/rawToTon");
const formatNumber_1 = require("../../../../utils/formatNumber");
const getRandomColor_1 = require("../../../../utils/getRandomColor");
const svg_selector_1 = require("../../../../assets/svg-selector");
// import QR from '../../../../assets/qr.svg'
const send_to_module_css_1 = __importDefault(require("./send-to.module.css"));
const SendTo = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [value, setValue] = (0, react_1.useState)('');
    const videoRef = (0, react_1.useRef)(null);
    const fileInputRef = (0, react_1.useRef)(null);
    const tonapi = new tonapi_1.TonApi();
    const TgObj = sdk_1.default;
    const checkCamera = async () => {
        const hasCamera = await qr_scanner_1.default.hasCamera();
        if (!hasCamera) {
            TgObj.showAlert(t('send.send-to-position.no-camera-found'));
            props.setIsScanned(false);
            return;
        }
        props.setIsScanned(true);
    };
    (0, react_1.useEffect)(() => {
        const initializeScanner = async () => {
            const videoElement = videoRef.current;
            if (!videoElement) {
                return;
            }
            try {
                const scanner = new qr_scanner_1.default(videoElement, (result) => {
                    try {
                        let res = result;
                        if (res.startsWith('ton://transfer/')) {
                            res = res.replace('ton://transfer/', '');
                        }
                        setValue(res);
                        props.setIsScanned(false);
                    }
                    catch (error) {
                        console.log(error);
                    }
                });
                scanner.start();
                // eslint-disable-next-line consistent-return
                return () => {
                    scanner.stop();
                };
            }
            catch (error) {
                console.error('Error initializing QR scanner:', error);
                props.setIsScanned(false);
            }
        };
        initializeScanner();
    }, [props.isScanned]);
    const SetAddres = async (value) => {
        if (value) {
            try {
                if (value.endsWith('.ton') || value.endsWith('.t.me')) {
                    const res = await tonapi.getAddressByDomainName(value);
                    if (!res || res?.wallet.address.length === 0) {
                        return;
                    }
                    const addr = ton_1.Address.parse(res?.wallet.address);
                    props.setSendData({
                        ...props.sendData,
                        sendAddress: addr.toString({ bounceable: false })
                    });
                    props.setPosition(2);
                }
                else {
                    if (!ton3_1.Address.isValid(value)) {
                        return;
                    }
                    // const addr = Address.parse(value)
                    props.setSendData({
                        ...props.sendData,
                        sendAddress: ton_1.Address.parse(value).toString({ bounceable: false })
                    });
                    props.setPosition(2);
                }
            }
            catch (err) {
                console.error(err);
            }
        }
    };
    (0, react_1.useEffect)(() => {
        SetAddres(value);
    }, [value]);
    const handleImportClick = () => {
        fileInputRef?.current?.click();
    };
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            reader.onload = (e) => {
                const qr = new qrcode_reader_1.default();
                qr.callback = (err, value) => {
                    if (err) {
                        console.error(err);
                    }
                    else {
                        let res = value.result;
                        if (res.startsWith('ton://transfer/')) {
                            res = res.replace('ton://transfer/', '');
                        }
                        setValue(res);
                    }
                };
                qr.decode(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: send_to_module_css_1.default.container, style: { height: '100%' }, children: [!props.isScanned && (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: send_to_module_css_1.default.modalTitle, children: t('send.send-to') }), !props.isScanned ? ((0, jsx_runtime_1.jsxs)("div", { className: send_to_module_css_1.default.seleсtWrapper, children: [(0, jsx_runtime_1.jsxs)("div", { className: send_to_module_css_1.default.searchInner, children: [(0, jsx_runtime_1.jsx)("div", { className: send_to_module_css_1.default.searchIcon, children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "search-2" }) }), (0, jsx_runtime_1.jsx)("input", { placeholder: t('send.send-to-position.search-input'), value: value, onChange: (e) => setValue(e.target.value), className: `${send_to_module_css_1.default.search} ${send_to_module_css_1.default.searchHome}` }), value.length >= 1 && ((0, jsx_runtime_1.jsx)("button", { className: send_to_module_css_1.default.searchClear, onClick: () => {
                                    setValue('');
                                }, children: (0, jsx_runtime_1.jsx)(de_ui_1.IconSelector, { id: "x", size: "20", color: "#98989E" }) })), (0, jsx_runtime_1.jsx)("div", { className: send_to_module_css_1.default.import, onClick: handleImportClick, children: (0, jsx_runtime_1.jsx)(de_ui_1.IconSelector, { id: "upload-cloud", color: "#98989E" }) }), (0, jsx_runtime_1.jsx)("div", { className: send_to_module_css_1.default.scan, onClick: () => checkCamera(), children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "qr-code", isTg: props.isTg }) }), (0, jsx_runtime_1.jsx)("input", { type: "file", ref: fileInputRef, style: { display: 'none' }, onChange: handleFileChange })] }), (0, jsx_runtime_1.jsx)("div", { className: send_to_module_css_1.default.transItems, children: props?.transHistory && props?.transHistory?.length > 0 ? ((() => {
                            const uniqueAddresses = new Set();
                            return props.transHistory.map((el) => {
                                const senderAddress = el?.actions[0].JettonTransfer?.sender?.address || el?.actions[0].TonTransfer?.sender?.address;
                                if (senderAddress && !uniqueAddresses.has(senderAddress)) {
                                    uniqueAddresses.add(senderAddress);
                                    const isSmartContract = el.actions[0].type === 'SmartContractExec';
                                    const amountJetton = (0, formatNumber_1.formatNumber)((0, ton_1.fromNano)([
                                        el?.actions[0]?.JettonTransfer?.amount,
                                        el?.actions[1]?.JettonTransfer?.amount,
                                        el?.actions[0]?.TonTransfer?.amount,
                                        el?.actions[1]?.TonTransfer?.amount,
                                        el?.actions[2]?.TonTransfer?.amount,
                                        el?.actions[2]?.JettonTransfer?.amount
                                    ].find(am => am !== undefined) || 0));
                                    return ((0, jsx_runtime_1.jsx)("div", { className: send_to_module_css_1.default.transItem, onClick: () => {
                                            TgObj.HapticFeedback.impactOccurred('medium');
                                            props.setSendData({
                                                ...props.sendData,
                                                sendAddress: (0, rawToTon_1.rawToTon)(senderAddress)
                                            });
                                            props.setPosition(2);
                                        }, style: {
                                            display: el.actions[0]?.status !== 'ok'
                                                || Number(amountJetton) === 0
                                                || isSmartContract
                                                || (0, rawToTon_1.rawToTon)(senderAddress) === props.addressUser
                                                ? 'none'
                                                : ''
                                        }, children: (0, jsx_runtime_1.jsxs)("div", { className: send_to_module_css_1.default.transItemLeft, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: send_to_module_css_1.default.transItemLogo, style: { background: (0, getRandomColor_1.getColorByNumber)(Number(String(el?.actions[0]?.TonTransfer?.amount).charAt(0))) }, children: (0, rawToTon_1.rawToTon)(senderAddress).slice(0, 2) }), (0, jsx_runtime_1.jsxs)("div", { className: send_to_module_css_1.default.transItemLeftBody, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: send_to_module_css_1.default.transItemLeftFrom, children: (0, smlAddr_1.smlAddrCheckout)((0, rawToTon_1.rawToTon)(senderAddress)) }), el.timestamp && ((0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: send_to_module_css_1.default.transItemDate, children: (0, formatTimestamp_1.formatTimestamp)(el.timestamp) }))] })] }) }, (0, uuid_1.v1)()));
                                }
                                return null;
                            });
                        })()) : ((0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: send_to_module_css_1.default.emptyTransactions, children: t('send.send-to-position.no-recent') })) })] })) : ((0, jsx_runtime_1.jsx)("div", { className: send_to_module_css_1.default.qrContent, children: (0, jsx_runtime_1.jsxs)("div", { className: send_to_module_css_1.default.qr, children: [(0, jsx_runtime_1.jsx)("video", { className: send_to_module_css_1.default.qrCamera, ref: videoRef, autoPlay: true, playsInline: true }), (0, jsx_runtime_1.jsx)("div", { className: send_to_module_css_1.default.qrBack, children: (0, jsx_runtime_1.jsx)("div", { className: send_to_module_css_1.default.qrArea, children: (0, jsx_runtime_1.jsx)(de_ui_1.Title, { className: send_to_module_css_1.default.scanText, variant: 'h5', children: "Scan your QR code" }) }) })] }) }))] }));
};
exports.SendTo = SendTo;
